//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'real-name-modal',
  data: function data() {
    return {
      realNameModalVisible: true
    };
  },
  methods: {
    closeModal: function closeModal() {
      this.realNameModalVisible = false;
    }
  }
};